import { SUBMIT_BULK_SCAN_LABELS } from "constants/actionTypes";
import { ScanLabelArchetype } from "constants/scanLabels";

export interface SubmitBulkScanLabelsAction {
  type: typeof SUBMIT_BULK_SCAN_LABELS;
  scanIds: string[];
  addLabelNames: string[];
  removeLabelNames: string[];
  archetypeByLabelName: Record<string, ScanLabelArchetype>;
}

export function submitBulkScanLabels(
  scanIds: string[],
  addLabelNames: string[],
  removeLabelNames: string[],
  archetypeByLabelName: Record<string, ScanLabelArchetype>,
): SubmitBulkScanLabelsAction {
  return {
    type: SUBMIT_BULK_SCAN_LABELS,
    scanIds,
    addLabelNames,
    removeLabelNames,
    archetypeByLabelName,
  };
}
